import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M2.158 1.5a.667.667 0 0 0 0 1.333h1.675l.444 2.217.01.052.928 4.633a1.78 1.78 0 0 0 1.77 1.432h5.39a1.78 1.78 0 0 0 1.77-1.432l.89-4.666a.667.667 0 0 0-.655-.791H5.482l-.448-2.242A.67.67 0 0 0 4.38 1.5zm4.365 7.976L5.749 5.61h7.825l-.737 3.865v.002a.444.444 0 0 1-.444.355H6.967a.444.444 0 0 1-.444-.357",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M5.38 13.278a1.222 1.222 0 1 1 2.444 0 1.222 1.222 0 0 1-2.444 0M11.491 13.278a1.222 1.222 0 1 1 2.445 0 1.222 1.222 0 0 1-2.445 0"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })